import { render, staticRenderFns } from "./ListaDistribucionForm.vue?vue&type=template&id=aa6fd1e4&scoped=true&"
import script from "./ListaDistribucionForm.vue?vue&type=script&lang=ts&"
export * from "./ListaDistribucionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ListaDistribucionForm.vue?vue&type=style&index=0&id=aa6fd1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6fd1e4",
  null
  
)

export default component.exports